import { get, isMockMode, simulateDelay } from "../api";

export const getOfferings = ({ orgId }) => {
	if (isMockMode()) {
		const testData = [
			{
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
				type: "Product",
			},
			{
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
				type: "Product",
			},
			{
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
				type: "Product",
			},
			{
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
				type: "Product",
			},
		];

		return simulateDelay(50, () => testData);
	}

	return get(`Offerings/GetForOrg?orgId=${orgId}`);
};
